export default "__VITE_ASSET__JqWz4WBJ__"